import React, { useState } from 'react';
import StepIndicator from './StepIndicator';
import Step1Form from './Step1Form';
import Step2Form from './Step2Form';
import ConfirmationModal from './ConfirmationModal.js'; 

const MultiStepInvestorForm = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [isModalOpen, setModalOpen] = useState(false); 

    // Handle transition from step 1 to step 2
    const handleNext = (values) => {
        setFormData(values);
        setStep(2);
    };

    // Handle form submission
    const handleSubmit = async (values) => {
        const finalFormData = new FormData();
        Object.entries({ ...formData, ...values }).forEach(([key, value]) => finalFormData.append(key, value));

        console.log('Form Data:', Object.fromEntries(finalFormData));

        // Show the modal after form submission
        setModalOpen(true);

        // Optionally reset form data here
        setFormData({});
    };

    // Handle modal actions
    const closeModal = () => setModalOpen(false);

    const handleGoBack = () => {
        window.location.href = '/'; 
    };

       const handleNewForm = () => {
        setModalOpen(false);  
        setStep(1);  
        setFormData({});  
    };

    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto bg-white shadow rounded-lg">
                <StepIndicator step={step} />
                {step === 1 ? (
                    <Step1Form handleNext={handleNext} formData={formData} />
                ) : (
                    <Step2Form handleSubmit={handleSubmit} setStep={setStep} formData={formData} setFormData={setFormData} />
                )}

                {/* Confirmation Modal for post-submission action */}
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    onGoBack={handleGoBack}
                    onNewForm={handleNewForm}
                />
            </div>
        </div>
    );
};

export default MultiStepInvestorForm;
